import React from "react";
import img1 from "../../assets/img/1.png";
import img2 from "../../assets/img/2.png";
import img3 from "../../assets/img/3.png";
import img4 from "../../assets/img/4.png";
import img5 from "../../assets/img/5.png";
import img6 from "../../assets/img/6.png";
import img7 from "../../assets/img/7.png";
import img8 from "../../assets/img/8.png";
import img9 from "../../assets/img/9.png";
import img10 from "../../assets/img/10.png";
import img11 from "../../assets/img/11.png";
import img12 from "../../assets/img/12.png";
import { NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
const HomeBrand = () => {
  const mockiBrandData = [
    { id: 46, title: "christian-louboutin", img: img1 },
    { id: 45, title: "bentley", img: img2 },
    { id: 47, title: "narciso-rodriguez", img: img3 },

    { id: 31, title: "paco-rabanne", img: img4 },
    { id: 11, title: "mancera", img: img5 },

    { id: 50, title: "parfums-de-marly", img: img6 },

    { id: 48, title: "memo-paris", img: img7 },
    { id: 10, title: "montale", img: img8 },

    { id: 37, title: "tiziana-terenzi", img: img9 },
    { id: 51, title: "victoria-s-secret", img: img10 },
    { id: 1, title: "xerjoff", img: img11 },
    { id: 40, title: "yves-saint-laurent", img: img12 },
  ];
  return (
    <>
      <section className="homeBrand my-5">
        <div className="container">
          <div className="section-title text-center">
            <h2 className="title pb-3 text-uppercase">Populyar Brendlər</h2>
          </div>
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={4}
            loop={true}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            breakpoints={{
              0: { slidesPerView: 2 },
              576: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              992: { slidesPerView: 5 },
            }}
          >
            <div className="row g-3">
              {mockiBrandData.map((item) => {
                return (
                  <SwiperSlide>
                    <NavLink to={`/perfume/${item.id}-${item.title}`}>
                      <div className="homeBrandImg bg-dark d-flex justify-content-center">
                        <img
                          src={item.img}
                          alt=""
                          className="img-fluid"
                          style={{
                            width: "50%",
                            height: "150px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    </NavLink>
                  </SwiperSlide>
                );
              })}
            </div>
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default HomeBrand;
